import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiEmployeeTerminationPayload } from "@/types/employees/employee-termination.types.ts";

export const apiEmployeeTermination = {
  create: async function (employeeId: number, payload: ApiEmployeeTerminationPayload) {
    return api.post<ApiOperationResult>(`/api/v1/employees/${employeeId}/terminations`, payload);
  },
  update: async function (
    employeeId: number,
    terminationId: number,
    payload: ApiEmployeeTerminationPayload
  ) {
    return api.put<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/terminations/${terminationId}`,
      payload
    );
  },
  delete: async function (employeeId: number, terminationId: number) {
    return api.delete<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/terminations/${terminationId}`
    );
  },
};
